<template>
    <DetailsSection class="step">
        <template slot="header">
            <media-only desktop>
                <span class="step-number">
                </span>
            </media-only>
            {{$t('Cancellation.header.refundInfo')}}
        </template>

        <template v-if="isRefundableAmountAvailable">
            <translate v-if="!isRefundableByValueVoucherOnly" tag="p" path="Cancellation.refund.commonText">
                <template v-if="isConvertibleToValueVoucher" v-slot:after>
                    {{$t('Cancellation.refund.toValueVoucher')}}
                </template>
            </translate>

            <template v-if="isValueVoucher">
                <p v-if="originalPaymentMethod === paymentMethods.payPal.value">
                    {{$t('Cancellation.refund.paypal.text')}}
                </p>
                <p v-else-if="originalPaymentMethod === paymentMethods.amazonPay.value">
                    {{$t('Cancellation.refund.amazonPay.text')}}
                </p>
                <p v-else-if="paidWithCreditCard">
                    {{$t('Cancellation.refund.creditcard.text')}}
                </p>
                <p v-else>
                    {{$t('Cancellation.refund.transfer.text')}}
                </p>
            </template>
            <template v-else>
                <div v-if="isRefundableByValueVoucherOnly">
                    <p>{{$t('Cancellation.refund.commonText.RefundableByValueVoucherOnly')}}</p>
                </div>
                <div v-else-if="isConvertibleToValueVoucher">
                    <p v-if="originalPaymentStatus === 'PartlyRefundable'">
                        {{$t('Cancellation.refund.partialVoucher.text')}}
                    </p>

                    <div class="custom-control custom-radio mb-2">
                        <input type="radio" id="refund1" v-model="refundMethodValue" value="Valuevoucher" class="custom-control-input">
                        <label for="refund1" class="custom-control-label">
                            {{$t('Cancellation.refund.voucherOption')}}
                        </label>
                    </div>

                    <div class="custom-control custom-radio">
                        <input type="radio" id="refund2" v-model="refundMethodValue" value="OriginalPaymentMethod" class="custom-control-input">
                        <label class="custom-control-label" for="refund2">
                            {{$t('Cancellation.refund.originalPaymentOption.' + originalPaymentMethod)}}
                        </label>
                    </div>
                </div>

                <p v-else>
                    {{$t('Cancellation.refund.voucher.text')}}
                </p>
            </template>
        </template>
        <template v-else>
            <p>
                {{$t('Cancellation.refund.noRefundableAmount')}}
            </p>
        </template>

    </DetailsSection>
</template>

<script>
    import DetailsSection from '@/components/DetailsSection';
    import paymentMethods from '@/models/paymentMethods';

    export default {
        name: 'RefundSection',
        components: {
            DetailsSection
        },
        data() {
            return {
                paymentMethods
            };
        },
        props: {
            isValueVoucher: {
                required: true,
                type: Boolean
            },
            originalPaymentStatus: {
                required: true,
                type: String
            },
            originalPaymentMethod: {
                required: true
            },
            amountToRefund: {
                required: true,
                type: Number
            },
            refundMethod: {
                required: true,
                type: String
            }
        },
        computed: {
            refundMethodValue: {
                get() {
                    return this.refundMethod;
                },
                set(value) {
                    this.$emit('update:refundMethod', value);
                }
            },
            isRefundableAmountAvailable() {
                return this.amountToRefund > 0;
            },
            isRefundableByValueVoucherOnly() {
                return this.originalPaymentStatus === "RefundableByValueVoucherOnly";
            },
            isConvertibleToValueVoucher() {
                return !this.isValueVoucher && (this.originalPaymentStatus === "FullRefundable" || this.originalPaymentStatus === "PartlyRefundable");
            },
            paidWithCreditCard() {
                return this.originalPaymentMethod === this.paymentMethods.stripe.value;
            }
        }
    }
</script>

<style scoped>

</style>
